import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=28540591&scoped=true"
import script from "./ProductSelect.vue?vue&type=script&lang=js"
export * from "./ProductSelect.vue?vue&type=script&lang=js"
import style0 from "./ProductSelect.vue?vue&type=style&index=0&id=28540591&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28540591",
  null
  
)

export default component.exports